<template>
  <div class="carousel">
    <transition name="fade">
      <template v-for="(img, i) in imgs">
        <div v-if="active === i" :key="`cimg-${i}`" :style="{ backgroundImage: `url(${img})` }"></div>
      </template>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['imgs'],
  data() {
    return {
      active: 0,
      interval: null,
      speed: 4000
    };
  },
  mounted() {
    setInterval(() => {
      if (this.active < this.imgs.length - 1) {
        this.active++;
      } else {
        this.active = 0;
      }
    }, this.speed);
  }
};
</script>

<style scoped lang="scss">
.carousel {
  width: 100%;
  height: 26vw;
  position: relative;
  div {
    background-position: center;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
